import { faList } from '@fortawesome/free-solid-svg-icons'
import { getNs } from 'common/i18n-config'

import { AINotice } from './ai-notice'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])

export const AIMultipleSuggestionNotice = () => {
  useNsReady()
  return (
    <AINotice
      className="multiple-suggestion-notice"
      icon={faList}
      title={t('multiple_suggestion_notice_title')}
      text={t('multiple_suggestion_notice_text')}
    />
  )
}
